import Webcam from 'react-webcam'
import renderImage from '../../../../source/importImg'
import * as faceapi from '@vladmandic/face-api/dist/face-api.esm-nobundle.js'
import { useEffect, useRef, useState } from 'react'
import styles from './ZingCam.module.css'

function ZingCam({
    utputText,
    setOutputText,
    generateBytes,
    isConnected,
    sendPack,
}) {
    const webcamRef = useRef(null)
    const canvasRef = useRef(null)
    const intervalRef = useRef(null)

    const [playPause, setPlayPause] = useState(true)
    const [stateload, setStateload] = useState(false)
    const [detectionMode, setDetectionMode] = useState('Direction')

    /* ---------------- LOAD MODELS ---------------- */
    useEffect(() => {
        const loadModels = async () => {
            const MODEL_URL = process.env.PUBLIC_URL + '/models'

            await Promise.all([
                faceapi.nets.tinyFaceDetector.loadFromUri(MODEL_URL),
                faceapi.nets.faceLandmark68Net.loadFromUri(MODEL_URL),
                faceapi.nets.faceExpressionNet.loadFromUri(MODEL_URL),
            ])

            setStateload(true)
        }

        loadModels()
    }, [])

    useEffect(() => {
        if (!stateload) return

        clearInterval(intervalRef.current)

        /* ---------------- DETECTION LOOP ---------------- */
        if (playPause) {
            intervalRef.current = setInterval(async () => {
                if (
                    !webcamRef.current ||
                    !webcamRef.current.video ||
                    webcamRef.current.video.readyState !== 4
                )
                    return

                const video = webcamRef.current.video
                const canvas = canvasRef.current
                const ctx = canvas.getContext('2d')

                // CRITICAL FIX
                canvas.width = video.videoWidth
                canvas.height = video.videoHeight

                const detection = await faceapi
                    .detectSingleFace(
                        video,
                        new faceapi.TinyFaceDetectorOptions({
                            inputSize: 224,
                            scoreThreshold: 0.5,
                        })
                    )
                    .withFaceLandmarks()
                    .withFaceExpressions()

                ctx.clearRect(0, 0, canvas.width, canvas.height)

                if (!detection) return

                const { box } = detection.detection
                ctx.strokeStyle = 'lime'
                ctx.lineWidth = 2
                // ctx.strokeRect(box.x, box.y, box.width, box.height)

                // ctx.font = '20px Arial'
                // ctx.fillStyle = 'red'

                /* ---------- EMOTION MODE ---------- */
                if (detectionMode === 'Emotion') {
                    const expressions = detection.expressions
                    const emotion = Object.keys(expressions).reduce((a, b) =>
                        expressions[a] > expressions[b] ? a : b
                    )

                    setOutputText(emotion)
                    // ctx.fillText(`Emotion: ${emotion}`, box.x, box.y)
                }

                /* ---------- DIRECTION MODE ---------- */

                if (detectionMode === 'Direction') {
                    const landmarks = detection.landmarks.positions

                    // Landmark indexes (68 model)
                    const noseTip = landmarks[30]
                    const leftEye = landmarks[36]
                    const rightEye = landmarks[45]

                    // Eye center
                    const eyeCenterX = (leftEye.x + rightEye.x) / 2
                    const eyeCenterY = (leftEye.y + rightEye.y) / 2

                    // Differences
                    const dx = noseTip.x - eyeCenterX // YAW
                    const dy = noseTip.y - eyeCenterY // PITCH

                    let direction = 'CENTER'

                    // const yawThreshold = 12
                    // const pitchThreshold = 10
                    const yawThreshold = [-10, 10]
                    const pitchThreshold = [30, 50]

                    // console.log('LLLLLLLLLLL', dx, dy)
                    // LEFT / RIGHT (Yaw)
                    if (dx > yawThreshold[1]) direction = 'RIGHT'
                    else if (dx < yawThreshold[0]) direction = 'LEFT'

                    // UP / DOWN (Pitch) – higher priority
                    if (dy > pitchThreshold[1]) direction = 'DOWN'
                    else if (dy < pitchThreshold[0]) direction = 'UP'

                    setOutputText(direction)

                    // ctx.fillText(`Direction: ${direction}`, box.x, box.y - 10)

                    // Optional debug
                    // ctx.beginPath()
                    // ctx.arc(noseTip.x, noseTip.y, 4, 0, Math.PI * 2)
                    // ctx.fillStyle = 'yellow'
                    // ctx.fill()
                    generateBytes(direction)
                }
            }, 100)
        } else {
            clearInterval(intervalRef.current)
        }

        return () => clearInterval(intervalRef.current)
    }, [stateload, detectionMode, playPause, isConnected, sendPack])

    const handelPalyPause = () => {
        setPlayPause(!playPause)
    }

    /* ---------------- UI ---------------- */
    return (
        <div className="Camera123">
            {/* <img
                className={styles.backgroundImg}
                src={renderImage('popup_Svg')}
                draggable="false"
            /> */}

            <div className={styles.camParentDiv}>
                <div className={styles.camDiv}>
                    {stateload ? (
                        <>
                            <Webcam
                                className={styles.webCam}
                                ref={webcamRef}
                                audio={false}
                                mirrored
                            />

                            <canvas
                                className={styles.camCanvas}
                                ref={canvasRef}
                            />
                        </>
                    ) : (
                        <p className={styles.loadText}>Loading AI Engine...</p>
                    )}
                </div>
            </div>

            <div className={styles.modeDiv}>
                {['Direction', 'Emotion', 'Pose'].map((mode) => (
                    <div
                        key={mode}
                        onClick={() =>
                            mode !== 'Pose' && setDetectionMode(mode)
                        }
                        style={{
                            padding: '12px 30px',
                            marginBottom: '15px',
                            cursor: mode === 'Pose' ? 'not-allowed' : 'pointer',
                            borderRadius: '20px',
                            background:
                                detectionMode === mode
                                    ? 'linear-gradient(90deg,#eae8e8,#ffffff)'
                                    : 'transparent',
                            color:
                                mode === 'Pose'
                                    ? 'rgba(0, 0, 0, 0.5)'
                                    : 'black',
                        }}
                    >
                        {mode}
                    </div>
                ))}
            </div>
        </div>
    )
}

export default ZingCam
